module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_3016.621dc5a8.png";